import React from "react";
import { DndContext,
  closestCenter,
} from "@dnd-kit/core";

import {
  SortableContext,
  arrayMove,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

function Item({ img, index, title, onTitleChange, onRemove }) {
  const { setNodeRef, attributes, listeners, transform, transition } =
    useSortable({ id: img.file.name + index });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: "flex",
    gap: "15px",
    alignItems: "center",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    marginBottom: "10px",
    background: "#fff",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <img
        src={URL.createObjectURL(img.file)}
        width="50" />

      <input
        type="text"
        value={title}
        className="form-control"
        placeholder="Enter image title"
        onChange={(e) =>
          onTitleChange(index, e.target.value)
        }
      />

      <button
        type="button"
        className="btn btn-danger btn-sm"
        onClick={() => onRemove(index)}
      >
        ❌
      </button>
    </div>
  );
}

export default function ProductMedia({ formData, setFormData }) {
  // const handleFile = (e) => {
  //   const files = Array.from(e.target.files);

  //   const newData = files.map((file) => ({
  //     file,
  //     title: ""
  //   }));

  //   setFormData((p) => ({
  //     ...p,
  //     images: [...p.images, ...newData],
  //   }));
  // };
  // const handleDragEnd = (event) => {
  //   const { active, over } = event;
  //   if (!over || active.id === over.id) return;
  //   const oldIndex = formData.images.findIndex(
  //     (img, i) => img.file.name + i === active.id
  //   );
  //   const newIndex = formData.images.findIndex(
  //     (img, i) => img.file.name + i === over.id
  //   );
  //   setFormData((p) => ({
  //     ...p,
  //     images: arrayMove(p.images, oldIndex, newIndex),
  //   }));
  // };
  return (
    <div>
<div className="mb-3">

  <label className="form-label">
    Thumbnail Image
  </label>

  <input
    type="file"
    className="form-control"
    accept="image/*"
    onChange={(e) => {

      const file = e.target.files[0];

      if (file) {

        setFormData((prev) => ({
          ...prev,
          thumbnail_image: file,
        }));
      }
    }}
  />
  {formData.thumbnail_image && (

  <div className="mb-3">

    <img
      src={URL.createObjectURL(formData.thumbnail_image)}
      alt="thumbnail"
      width="120"
      style={{
        borderRadius: "10px",
        objectFit: "cover",
      }}
    />

  </div>
)}

</div>

      {/* <div className="mb-3">

        <label className="form-label">
          Product Images
        </label>

        <input
          type="file"
          multiple
          className="form-control"
          onChange={handleFile}
        />

      </div> */}

      {/* <DndContext
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={formData.images.map((img, i) => img.file.name + i)}
          strategy={verticalListSortingStrategy}
        >
          {formData.images.map((item, i) => (
            <Item
              key={item.file.name + i}
              img={item}
              index={i}
              title={item.title}
              onTitleChange={(idx, value) => {

                const updated = [...formData.images];

                updated[idx].title = value;

                setFormData((p) => ({
                  ...p,
                  images: updated,
                }));
              }}
              onRemove={(idx) => {

                const updated = formData.images.filter(
                  (_, index) => index !== idx
                );

                setFormData((p) => ({
                  ...p,
                  images: updated,
                }));
              }}
            />
          ))}
        </SortableContext>
      </DndContext> */}
    </div>
  );
}